import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './layouts.scss';
import '../styles/default.scss'
import { useDispatch, useSelector } from 'react-redux';
import { updateParameters } from '../store/globalSlice';
import { GetSystemParameters } from '../api/system';
import 'leaflet/dist/leaflet.css';
import moment from 'moment';
import { ClearUser } from '../store/userSlice';

const DefaultLayout = () => {
  const user = useSelector (state=> state.user)
  const dispatch = useDispatch()
  const path = useLocation().pathname
  const navigate = useNavigate()
  useEffect(()=>{
    GetSystemParameters().then(res=>{
      let obj={}
      res.groups.forEach(g=>{
        
        obj[g.groupName] = {name:g.describe, data: 
          g.groupName=== "CarType" ? 
          g.nouns.reverse() :
          g.nouns
        }
      })
      dispatch(updateParameters(obj))
    })

    if(user?.identities){
      //保留24小時
      let check = moment(user.identities.date).add(24,"h").format()
      let unvalid = moment(moment().format()).isAfter(check)
      if(unvalid) {
        dispatch(ClearUser())
        navigate("/")
      }

    }
  },[])


  useEffect(()=>{
    // let container = document.querySelector("body");
    window.scrollTo(0, 0);
    if(path !=="/"){
      
    }
  },[path])
  return (
    <div className='layout'>
        <Outlet />
        {/* {children} */}
        <footer>
        客服專線：0800-018-119
        </footer>
    </div>
    
  )
}

export default DefaultLayout